import {
  FacebookFilled,
  InstagramFilled,
  MailOutlined,
  PhoneOutlined,
  TwitterOutlined,
} from '@ant-design/icons';
import { LogoGroup } from '@/components/shared';

const FooterSection = () => {
  return (
    <footer className="bg-green-800 text-white pt-32 pb-8 px-6 md:px-16">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
        {/* Left: Logo + Description */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <LogoGroup
              virtualHubClassName="h-10 w-10"
              isatUClassName="h-10 w-10"
            />
            <h4 className="text-lg font-bold">VIRTUAL HUB</h4>
          </div>
          <p>
            DA Virtual Hub is the first digital platform in Western Visayas that
            connects farmers and fisherfolk directly to consumers, providing
            them with a fair price for their produce.
          </p>
        </div>

        {/* Middle: Links */}
        <div className="flex flex-col gap-2">
          <a href="#about" className="hover:underline">
            About
          </a>
          <a href="#faq" className="hover:underline">
            FAQs
          </a>
          <a href="/register/market" className="hover:underline">
            Register as Market
          </a>
          <a href="/register/coop" className="hover:underline">
            Register as Cooperative
          </a>
          <a href="/login" className="hover:underline">
            Login
          </a>
        </div>

        {/* Right: Contact Info */}
        <div className="space-y-2">
          <p>
            Research Hub, New-site, Iloilo Science and Technology University, La
            Paz, Iloilo City, Philippines, 5000
          </p>
          <p>
            <PhoneOutlined className="mr-2" />
            (033) 320-7190 loc 290
          </p>
          <p>
            <MailOutlined className="mr-2" />
            virtualhub.doa@gmail.com
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-10 border-t border-white/20 pt-4 flex justify-between items-center text-xs text-white/70">
        <span>© 2025 DA Virtual Hub.</span>
        <div className="flex space-x-4">
          <a href="#" aria-label="Facebook" className="hover:text-white">
            <FacebookFilled />
          </a>
          <a href="#" aria-label="Instagram" className="hover:text-white">
            <InstagramFilled />
          </a>
          <a href="#" aria-label="Twitter" className="hover:text-white">
            <TwitterOutlined />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
